export const SITE_NAME = process.env.GATSBY_SITE_NAME || 'SAI Group Of Industries'
export const SITE_SHORT_NAME = process.env.GATSBY_SITE_SHORT_NAME || 'SAIGOI'
export const SITE_ADDRESS = process.env.GATSBY_SITE_ADDRESS || 'Lalitpur, Nepal'
export const SITE_DOMAIN = process.env.GATSBY_SITE_DOMAIN || 'saigoi.com'
